<template>
  <div class="flex">
    <button
      data-cy="kick-user"
      v-if="showKickParticipantOption"
      @click="sendKickParticipantCommand"
    >
      <UserRemoveIcon
        :class="['h-6 w-6 mr-2 shadow-filter']"
        :muted="!userProps[currentPhase]?.[userId]?.['audio']"
      />
    </button>
    <button
      data-cy="mute-user"
      @click="muteParticipant"
      :class="{ 'cursor-default': !sessionStore.isClinician }"
    >
      <ViceMicrophone
        pathFill="gray"
        lineOneStroke="gray"
        lineTwoStroke="gray"
        :class="['h-6 w-6 mr-2 shadow-filter']"
        :muted="!userProps[currentPhase]?.[userId]?.['audio']"
      />
    </button>
    <div>
      <CameraMutedIcon
        pathFill="gray"
        v-if="!userProps[currentPhase]?.[userId]?.['video']"
        class="h-6 w-6 mr-2 shadow-filter"
      />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { UserRemoveIcon } from '@heroicons/vue/solid';
import ViceMicrophone from '@/Components/Icons/ViceMicrophone.vue';
import CameraMutedIcon from '@/Components/Icons/CameraMutedIcon.vue';
import useSessionStore from '@/Stores/useSessionStore.js';

export default {
  props: {
    userId: {
      type: [Number, String],
      required: true,
    },
    muteSingleParticipant: {
      type: Function,
    },
    kickParticipant: {
      type: Function,
    },
  },
  components: {
    ViceMicrophone,
    CameraMutedIcon,
    UserRemoveIcon,
  },

  setup(props) {
    const sessionStore = useSessionStore();
    const userProps = computed(() => sessionStore.activeCallParticipants);
    const currentPhase = computed(() => sessionStore.currentPhase);

    const jitsiUserId = computed(
      () => userProps.value[currentPhase.value]?.[props.userId]?.jitsiUserId,
    );
    const isRemoteUser = computed(
      () => userProps.value[currentPhase.value]?.[props.userId]?.isRemoteUser,
    );

    const showKickParticipantOption = computed(
      () => sessionStore.isClinician && isRemoteUser.value,
    );

    const canMuteParticipant = computed(
      () => props.muteSingleParticipant && jitsiUserId.value && isRemoteUser.value,
    );

    const muteParticipant = () => {
      if (canMuteParticipant.value) {
        props.muteSingleParticipant(jitsiUserId.value);
      }
    };

    const sendKickParticipantCommand = () => {
      props.kickParticipant(jitsiUserId.value);
    };

    return {
      showKickParticipantOption,
      userProps,
      currentPhase,
      muteParticipant,
      sendKickParticipantCommand,
      sessionStore,
    };
  },
};
</script>

<style></style>
